import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

interface LanguageSwitcherProps {
  variant?: 'default' | 'ghost' | 'outline';
  size?: 'default' | 'sm' | 'icon';
  className?: string;
}

const LanguageSwitcher = ({ variant = 'ghost', size = 'sm', className = '' }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language?.startsWith('ar');

  const toggle = () => {
    const newLang = isArabic ? 'en' : 'ar';
    i18n.changeLanguage(newLang);
    localStorage.setItem('fnhub-lang', newLang);
  };

  return (
    <Button variant={variant} size={size} onClick={toggle} className={`gap-1.5 ${className}`}>
      <Globe className="h-4 w-4" />
      <span className="text-xs font-semibold">{isArabic ? 'EN' : 'عربي'}</span>
    </Button>
  );
};

export default LanguageSwitcher;
